module.exports = __webpack_public_path__ + "static/CleverDevelopment-a647e93f9e6c1f85c72019d87c00a93f.png";